module.exports = __webpack_public_path__ + "static/media/selo-selection.d8a93886.png";